import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Sidebar from "./components/Sidebar";

const App = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  // Routes where header and footer should be hidden
  const hideHeaderFooterRoutes = ['/login', '/signup', '/forgot', '/otp'];
  const shouldHideHeaderFooter = hideHeaderFooterRoutes.includes(location.pathname);

  return (
    <div id="root">
      {!shouldHideHeaderFooter && <Header onSidebarToggle={toggleSidebar} />}
      {!shouldHideHeaderFooter && <Sidebar isOpen={isSidebarOpen} onClose={toggleSidebar} />}
      <main>
        <div className={shouldHideHeaderFooter ? "" : "container"}>
          <Outlet />
        </div>
      </main>
      {!shouldHideHeaderFooter && <Footer />}
      <ToastContainer />
    </div>
  );
};

export default App;
